import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { fetchConfluenceAppLinks } from '@atlassian/jira-servicedesk-knowledge-services/src/services/confluence/index.tsx';
import { FETCH_APPLINKS } from '../../state/actions/fetch-applinks';
import { fetchAppLinksFailure } from '../../state/actions/fetch-applinks-failure';
import { fetchAppLinksSuccess } from '../../state/actions/fetch-applinks-success';
import { getProjectKey } from '../../state/selectors/base';
import type { State } from '../../state/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const epic = (action$: ActionsObservable<any>, store: MiddlewareAPI<State>) =>
	action$.ofType(FETCH_APPLINKS).mergeMap(() => {
		const projectKey = getProjectKey(store.getState());

		return fetchConfluenceAppLinks(projectKey)
			.mergeMap((appLinks) => Observable.of(fetchAppLinksSuccess(appLinks.appLinks)))
			.catch(({ statusCode }) => Observable.of(fetchAppLinksFailure({ statusCode })));
	});
